import { render, staticRenderFns } from "./LLTags.vue?vue&type=template&id=050eeb4d&scoped=true"
import script from "./LLTags.vue?vue&type=script&lang=js"
export * from "./LLTags.vue?vue&type=script&lang=js"
import style0 from "./LLTags.vue?vue&type=style&index=0&id=050eeb4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050eeb4d",
  null
  
)

export default component.exports